import { createAsyncThunk } from '@reduxjs/toolkit';
import RoleApi from '@infrastructure/role-api';
import { getErrorPayload } from '@application/helpers/api-helper';
export const getAllRolesAsync = createAsyncThunk('role/getAll', async (params, { rejectWithValue }) => {
    try {
        const response = await RoleApi.getAllRoles(params);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createRoleAsync = createAsyncThunk('role/create', async (role, { rejectWithValue }) => {
    try {
        const response = await RoleApi.createRole(role);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createRoleWithPermissionsAsync = createAsyncThunk('role/createWithPermissions', async (role, { rejectWithValue }) => {
    try {
        const response = await RoleApi.createRoleWithPermissions(role);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateRoleWithPermissionsAsync = createAsyncThunk('role/updateWithPermissions', async (role, { rejectWithValue }) => {
    try {
        const response = await RoleApi.updateRoleWithPermissions(role);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getRoleByIdAsync = createAsyncThunk('role/getRoleById', async (roleId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await RoleApi.getRoleById(roleId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateRoleAsync = createAsyncThunk('role/update', async (role, { rejectWithValue }) => {
    try {
        const response = await RoleApi.updateRole(role);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteRoleAsync = createAsyncThunk('role/delete', async (roleId, { rejectWithValue }) => {
    try {
        const response = await RoleApi.deleteRole(roleId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getCompanyRolesAsync = createAsyncThunk('role/getRolesByCompanyId', async (payload, { rejectWithValue }) => {
    try {
        const response = await RoleApi.getCompanyRoles(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const toggleRoleActiveAsync = createAsyncThunk('role/update-status', async (roleId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await RoleApi.updateRoleStatusApi(roleId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getRolePermissionsAsync = createAsyncThunk('role/get-permissions', async (roleId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await RoleApi.getRolePermissions(roleId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateRolePermissionsAsync = createAsyncThunk('role/update-permissions', async (rolePermissions, { rejectWithValue }) => {
    try {
        const response = await RoleApi.updateRolePermissionsApi(rolePermissions);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
